import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { Button, Columns, Form, Notification, Section } from 'react-bulma-components';
import { useNavigate, useLocation } from "react-router-dom";

// actions
import { useAuth, useTokenStatus } from 'shared/state/auth/actions';

// Styles
import styles from './Login.module.scss';
import LoginImg from 'shared/media/login-img.jpg';

// TODO: Validate fields before sending
const Login = () => {
    const navigate = useNavigate();
    let location = useLocation();
    const { authLogin, authForgotPassord } = useAuth();

    const { Input, Field, Control, Label } = Form;
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [enableForgotPassword, setEnableForgotPassword] = useState(false);
    const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const [notification, setNotification] = useState({ type: null, message: ''});
    const { handleTokenStatus } = useTokenStatus();
    const today= new Date();
    const year = today.getFullYear();

    const handleLogin = (e) => {
        e.preventDefault();

        const params = {
            email: email,
            password: password,
        };

        authLogin(params)
            .then((response) => {
                if(response.logged_in){
                    // Redirect to previous url if exists in router
                    let from = location.state?.from?.pathname || "/";
                    response.result === 'member'
                        ? navigate('/', { replace: true })
                        : navigate(from, { replace: true });

                } else {
                    handleTokenStatus(response.result);
                }
            });
    }

    const onChangeEmail = (e) => {
        const user_email = e.target.value;
        setEmail(user_email);
    };

    const onChangePassword = (e) => {
        const user_password = e.target.value;
        setPassword(user_password);
    };

    const onClickForgotPassword = (e) => {
        e.preventDefault();
        setEnableForgotPassword(true);
    };

    const onChangeForgotPasswordEmail = (e) => {
        setForgotPasswordEmail(e.target.value);
    };

    const handleForgotPassword = (e) => {
        e.preventDefault();
        setIsProcessing(true);
        setNotification({type: null, message: ''});
        authForgotPassord({email: forgotPasswordEmail })
            .then((response) => {
                setIsProcessing(false);
                console.log('response ', response.message.message);
                if(response.status){
                    setNotification({type: 'danger', message: response.message.message});
                } else {
                    setNotification({type: 'success', message: response.result.message + '. Check your inbox for instructions.' });
                }
        });
    };

    const clearState = (e) => {
        e.preventDefault();
        setEnableForgotPassword(false);
        setNotification({type: null, message: ''});
        setForgotPasswordEmail('');
    };

    const loginTitle= enableForgotPassword ? '<span>TheThrivers</span> Program' : 'Welcome to <br><span>TheThrivers</span> Program' 

    return (
        <Columns className="is-gapless has-background-white" style={{ height: '100%'}}>
            <Columns.Column>
                <div className={ styles.login }>
                    <Section className={ styles.wrapper }>
                        <h1 dangerouslySetInnerHTML={{ __html: loginTitle }} />
                         { enableForgotPassword ?
                         <form onSubmit={ handleForgotPassword }>
                             <Field>
                                 <p>Password recovery </p>
                                 <hr />
                                 <Label>Your email address</Label>
                                 <Control>
                                     <Input
                                     placeholder="you@example.com"
                                     required
                                     value={ forgotPasswordEmail }
                                     onChange={ onChangeForgotPasswordEmail }
                                     />
                                     { notification.type !== null &&
                                         <small className={`has-text-${notification.type}`}>
                                            { notification.message }
                                         </small>
                                     }
                                 </Control>
                             </Field>
                             <Field>
                                 <Control>
                                     <Button loading={ isProcessing } fullwidth type="submit" color="primary">
                                        Reset Password
                                    </Button>
                                 </Control>
                             </Field>
                             <div className="has-text-right">
                                 <Button color="ghost" renderAs={Link} to="/login" onClick={ clearState }>
                                     <small> Back to login</small>
                                 </Button>
                             </div>
                         </form>
                         :
                        <form onSubmit={ handleLogin }>
                            <Field>
                                <Label>Email Address</Label>
                                <Control>
                                    <Input
                                    placeholder="you@example.com"
                                    required
                                    value={ email }
                                    onChange={ onChangeEmail }
                                    />
                                </Control>
                            </Field>
                            <Field>
                                <Label>Password</Label>
                                <Control>
                                    <Input
                                    required
                                    type="password"
                                    value={ password }
                                    onChange={ onChangePassword }
                                    />
                                </Control>
                            </Field>
                            <Field>
                                <Control>
                                    <Button fullwidth type="submit" color="primary">Login</Button>
                                </Control>
                            </Field>
                            <div className="has-text-right">
                                <Button color="ghost" onClick={ onClickForgotPassword }>
                                    <small>Forgot password?</small>
                                </Button>
                            </div>
                        </form>
                        }

                        <footer className={ styles.footer }>
                            @{year} TheThrivers. All rights reserved.
                        </footer>
                    </Section>
                </div>
            </Columns.Column>
            <Columns.Column>
                <img className={ styles.img } src={ LoginImg } alt="TheThrivers program login"/>
            </Columns.Column>
        </Columns>
    );
};

export default Login;
